import {
  TOGGLE_EXPANDED_POSSESSIONS,
} from 'actiontypes/myself';

/** ----------------------------------------------------------------------------
 * TOGGLE POSSESIONS (STANDARD / EXPANDED)
 -----------------------------------------------------------------------------*/

export default function toggleExpandedPossessions() {
  return { type: TOGGLE_EXPANDED_POSSESSIONS };
}
